import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propArrayShape, propBool } from '../../../../helpers/custom-prop-types';
import AboutRowListWrapper from '../../../Ui/Professional/About/AboutRowListWrapper';
import SectionCareerOne from './SectionCareerOne';
const SectionCareer = (props) => {
    const { careers, isBlur } = props;
    return (_jsxs("div", Object.assign({ className: 'about-consultant-career' }, { children: [_jsx(AboutRowListWrapper, Object.assign({ buttonClassName: 'is-consultant', className: 'experiences is-consultant', maxCount: 2, name: 'careers', rows: careers, wrapComponent: 'dl' }, { children: _jsx(SectionCareerOne, { isBlur: isBlur }) })), _jsx(AboutRowListWrapper, Object.assign({ buttonClassName: 'is-consultant', className: 'experiences is-consultant', minCount: 2, name: 'careers', rows: careers, wrapComponent: 'dl' }, { children: _jsx(SectionCareerOne, { isBlur: isBlur }) }))] })));
};
SectionCareer.propTypes = {
    careers: propArrayShape().isRequired,
    isBlur: propBool().isRequired,
};
export default SectionCareer;
